module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UNIahm/tc-custom/9781426843181.jpg?1704455086722",
      "alt": "This image is the cover for the book Magnum Force Man, Maximum Men"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Magnum Force Man, Maximum Men\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("He had little memory of who he was or where he'd been, but the images that kept flashing through his mind meant computer genius Claudia Reynolds was headed for danger and only Jack Maddox could rescue her. Although they'd technically met before, it wasn't until the bullets started to fly that the blond beauty was convinced to follow him through the remote South Dakota woods…far from the mysterious facility that Jack had once called home. Now, as Jack sensed they were closing in on answers too many people had died covering up, the long-forgotten pain buried deep in his past proved their connection was the only thing he could rely on. And the only thing keeping Claudia alive."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amanda Stevens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amanda Stevens is an award-winning author of over fifty novels. Born and raised in the rural south, she now resides in Houston, Texas.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0